import { useState, FormEvent, ChangeEvent } from 'react'
import { Spinner } from '@/components/ui/spinner'
import { sendPasswordResetEmail } from '../../services/auth'
import { Link } from 'react-router-dom'
import { Button } from '../ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Icon } from '../ui/icon'
import {
  faCircleExclamation,
  faCircleCheck,
} from '@awesome.me/kit-e215ba4646/icons/sharp/light'
import { AuthMessages } from '@/constants/messages'
import { TextLink } from '@/components/ui/text-link'
import { AuthPageFrame } from './AuthPageFrame'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setError('')
    setSuccess(false)
    setLoading(true)

    const result = await sendPasswordResetEmail(email)

    if (result.success) {
      setSuccess(true)
    } else {
      setError(AuthMessages.resetPasswordFailed)
    }

    setLoading(false)
  }

  return (
    <AuthPageFrame>
      <div className="flex flex-col space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          Reset Password
        </h1>
        <p className="text-sm text-muted-foreground">
          Enter your email and we&apos;ll send you a reset link
        </p>
      </div>

      {error && (
        <Alert variant="destructive">
          <Icon icon={faCircleExclamation} className="h-4 w-4" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      {success && (
        <Alert>
          <Icon icon={faCircleCheck} className="h-4 w-4" />
          <AlertDescription>{AuthMessages.resetPasswordSent}</AlertDescription>
        </Alert>
      )}

      {!success ? (
        <div className="grid gap-6">
          <form onSubmit={handleSubmit}>
            <div className="grid gap-4">
              <div className="grid gap-1">
                <Label className="sr-only" htmlFor="email">
                  Email
                </Label>
                <Input
                  id="email"
                  placeholder="name@example.com"
                  type="email"
                  autoCapitalize="none"
                  autoComplete="email"
                  autoCorrect="off"
                  disabled={loading}
                  value={email}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setEmail(e.target.value)
                  }
                  required
                />
              </div>
              <Button type="submit" disabled={loading}>
                {loading && <Spinner className="mr-2" />}
                Send Reset Link
              </Button>
            </div>
          </form>
        </div>
      ) : (
        <Button variant="outline" asChild>
          <Link to="/signin">Back to Sign In</Link>
        </Button>
      )}

      <p className="px-8 text-center text-sm">
        <TextLink to="/signin">Back to Sign In</TextLink>
      </p>
    </AuthPageFrame>
  )
}

export default ForgotPassword
